import { render } from "./OrdersEditView.vue?vue&type=template&id=7e6cccc6"
import script from "./OrdersEditView.vue?vue&type=script&lang=js"
export * from "./OrdersEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__